exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml, body {\n  height: 100%;\n  font-family: 'Josefin Sans', sans-serif;\n  color: #fefff6; }\n\n.full-height {\n  height: 100%; }\n\n.row {\n  margin-bottom: 0px; }\n\n.footer-home {\n  position: fixed;\n  bottom: 0;\n  z-index: -2;\n  visibility: hidden; }\n\nnav {\n  height: 50px;\n  box-shadow: none;\n  background-color: #3c3c3c;\n  position: relative;\n  margin-top: -15px; }\n  nav .nav-wrapper .brand-logo {\n    padding-left: 5px;\n    line-height: 50px;\n    font-size: 16px; }\n  nav .nav-wrapper .right li {\n    line-height: 50px; }\n    nav .nav-wrapper .right li a {\n      font-size: 16px;\n      transition: font-size .2s; }\n      nav .nav-wrapper .right li a i.fa {\n        height: 50px;\n        line-height: 50px; }\n    nav .nav-wrapper .right li a:hover {\n      background-color: transparent !important;\n      font-size: 25px;\n      font-weight: bolder;\n      color: goldenrod;\n      line-height: 30px; }\n\n@media (max-width: 1000px) {\n  .nav-wrapper .brand-logo {\n    left: 0;\n    transform: translateX(0); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/shared/footer/footer.component.scss
// module id = ../../../../../src/app/shared/footer/footer.component.scss
// module chunks = main